import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/CompressorRefrigerantModels";

export const COMPRESSOR_REFRIGERANT_MODELS_PREFIX_URL = PREFIX_URL;

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}/GetAll`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}/Create`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/GetById/:id`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/Update/:id`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/Delete/:id`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
